import React, { useState, useEffect } from "react";
import Tabs from "../../../Component/DigitalMarketing/Tabs";
import { useGetPatientCountsQuery } from "../../../Service/dashboard";

const PatientCount = () => {
  const [active, setActive] = useState(1);
  const [countData, setCountData] = useState([]);
  const values = [
    { id: 1, name: "Patient" },
    { id: 2, name: "Labs" },
    { id: 3, name: "Care Packages" },
  ];

  const {
    data: patientData,
    refetch,
    isLoading,
  } = useGetPatientCountsQuery({
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (patientData && patientData.data) {
      const data = patientData.data; // Ensure `patientData` is defined before accessing `data`
      
      switch (active) {
        case 1: // Patient
          setCountData([
            {
              id: "1",
              label: "Total Patients",
              count: data.patientRate?.totalPatients,
              bgcolor: true,
            },
            {
              id: "2",
              label: "IVF Patients",
              count: data.patientRate.ivfPatients,
            },
            {
              id: "3",
              label: "Other Patients",
              count: data.patientRate.otherPatients,
            },
          ]);
          break;
        case 2: // Labs
          setCountData([
            {
              id: "1",
              label: "Total Labs",
              count: data.labRate.totalLabs,
              bgcolor: true,
            },
            { id: "2", label: "Active Labs", count: data.labRate.activeLabs },
            { id: "3", label: "Test Orders", count: data.labRate.testOrders },
          ]);
          break;
        case 3: // Care Packages
          setCountData([
            {
              id: "1",
              label: "Total Packages",
              count: data.carePackages.totalPackages,
              bgcolor: true,
            },
            {
              id: "2",
              label: "Active Packages",
              count: data.carePackages.activePackages,
            },
            {
              id: "3",
              label: "Assigned Packages",
              count: data.carePackages.assignedPackages,
            },
          ]);
          break;
        default:
          break;
      }
    }
  }, [active, patientData]);

  return (
    <div>
      <Tabs tablist={values} active={active} setActive={setActive} />
      <div className="row gap-2 p-1">
        {countData?.map((d) => (
          <div
            className="cards mt-3"
            key={d?.id}
            style={{
              backgroundColor: d?.bgcolor ? "#EFF8FF" : "#fff",
              width: "180px",
            }}
          >
            <div>
              <span className="f-16 fw-400">{d?.label}</span>
            </div>
            <div>
              <span className="f-32 fw-600">{d?.count}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PatientCount;
